//
export const AuthenUserMock = {
  user: {
    username: 'nguyenthilan',
    password: '123qwe@..',
    accountType: 'NHAN_VIEN'
  },
  loginResponse: {
    token: 'ey...',
    user: {
      id: '12398415936892',
      image: '',
      ho_ten: 'nguyenthilan',
      email: 'nguyenthilan@gmail.com',
    },
    menu: ["5001", "5102", "5108", "5106", "5107", "5117", "5116", "5101", "5100", "5115", "5114", "5104", "5105", "5103", "5118", "5119", "5120"]
  },
  appKey: 'ROYAL_EDURA',
};


// export const AuthenUserMock = {
//   user: {
//     username: 'NNV0050588',
//     password: '123qwe@..',
//     accountType: 'NHAN_VIEN'
//   },
//   loginResponse: {
//     token: 'ey...',
//     user: {
//       id: '12398415936892',
//       image: '',
//       ho_ten: 'Developer',
//       email: 'Developer@gmail.com',
//     },
//     menu: [300038, 300036, 300037, 300039],
//   },
//   appKey: 'ROYAL_EDURA',
// };
